
    var doc = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"ordenCompraFind"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}},"directives":[]}],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"ordenCompraFind"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"proveedorId"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"depositoId"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"proveedor"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"nombre"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"cuit"},"arguments":[],"directives":[]}]}},{"kind":"Field","name":{"kind":"Name","value":"deposito"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"nombre"},"arguments":[],"directives":[]}]}},{"kind":"Field","name":{"kind":"Name","value":"items"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"producto"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"productoNombre"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"productoMarca"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"productoModelo"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"productoTamanio"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"cantidad"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"precioUnitario"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"precioTotal"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"precioBase"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"precioManual"},"arguments":[],"directives":[]}]}},{"kind":"Field","name":{"kind":"Name","value":"descuento"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"recargo"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"precioTotal"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"subtotalConOfertas"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"descuentoMonto"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"recargoMonto"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"fecha"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"numeroOrdenCompra"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"estadoConfirmacion"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"estadoRecepcion"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"estadoOrdenCompra"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"puedeEditarContenido"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"estadoPago"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"fechaPagoCompletado"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"totalPagado"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"restoAPagar"},"arguments":[],"directives":[]}]}}]}}],"loc":{"start":0,"end":668}};
    doc.loc.source = {"body":"query ordenCompraFind($id: ID!) {\n  ordenCompraFind(id: $id) {\n    id\n    proveedorId\n    depositoId\n    proveedor { id nombre cuit }\n    deposito { id nombre }\n    items {\n      producto\n      productoNombre\n      productoMarca\n      productoModelo\n      productoTamanio\n      cantidad\n      precioUnitario\n      precioTotal\n      precioBase\n      precioManual\n    }\n    descuento\n    recargo\n    precioTotal\n    subtotalConOfertas\n    descuentoMonto\n    recargoMonto\n    fecha\n    numeroOrdenCompra\n    estadoConfirmacion\n    estadoRecepcion\n    estadoOrdenCompra\n    puedeEditarContenido\n    estadoPago\n    fechaPagoCompletado\n    totalPagado\n    restoAPagar\n  }\n}\n","name":"GraphQL request","locationOffset":{"line":1,"column":1}};
  

    var names = {};
    function unique(defs) {
      return defs.filter(
        function(def) {
          if (def.kind !== 'FragmentDefinition') return true;
          var name = def.name.value
          if (names[name]) {
            return false;
          } else {
            names[name] = true;
            return true;
          }
        }
      )
    }
  

    // Collect any fragment/type references from a node, adding them to the refs Set
    function collectFragmentReferences(node, refs) {
      if (node.kind === "FragmentSpread") {
        refs.add(node.name.value);
      } else if (node.kind === "VariableDefinition") {
        var type = node.type;
        if (type.kind === "NamedType") {
          refs.add(type.name.value);
        }
      }

      if (node.selectionSet) {
        node.selectionSet.selections.forEach(function(selection) {
          collectFragmentReferences(selection, refs);
        });
      }

      if (node.variableDefinitions) {
        node.variableDefinitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }

      if (node.definitions) {
        node.definitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }
    }

    var definitionRefs = {};
    (function extractReferences() {
      doc.definitions.forEach(function(def) {
        if (def.name) {
          var refs = new Set();
          collectFragmentReferences(def, refs);
          definitionRefs[def.name.value] = refs;
        }
      });
    })();

    function findOperation(doc, name) {
      for (var i = 0; i < doc.definitions.length; i++) {
        var element = doc.definitions[i];
        if (element.name && element.name.value == name) {
          return element;
        }
      }
    }

    function oneQuery(doc, operationName) {
      // Copy the DocumentNode, but clear out the definitions
      var newDoc = {
        kind: doc.kind,
        definitions: [findOperation(doc, operationName)]
      };
      if (doc.hasOwnProperty("loc")) {
        newDoc.loc = doc.loc;
      }

      // Now, for the operation we're running, find any fragments referenced by
      // it or the fragments it references
      var opRefs = definitionRefs[operationName] || new Set();
      var allRefs = new Set();
      var newRefs = new Set();

      // IE 11 doesn't support "new Set(iterable)", so we add the members of opRefs to newRefs one by one
      opRefs.forEach(function(refName) {
        newRefs.add(refName);
      });

      while (newRefs.size > 0) {
        var prevRefs = newRefs;
        newRefs = new Set();

        prevRefs.forEach(function(refName) {
          if (!allRefs.has(refName)) {
            allRefs.add(refName);
            var childRefs = definitionRefs[refName] || new Set();
            childRefs.forEach(function(childRef) {
              newRefs.add(childRef);
            });
          }
        });
      }

      allRefs.forEach(function(refName) {
        var op = findOperation(doc, refName);
        if (op) {
          newDoc.definitions.push(op);
        }
      });

      return newDoc;
    }
    
    module.exports = doc;
    
        module.exports["ordenCompraFind"] = oneQuery(doc, "ordenCompraFind");
        
